import { ChangeDetectionStrategy, Component, input, signal, WritableSignal } from '@angular/core';

import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-images-carousel',
    templateUrl: './images-carousel.component.html',
})
export class ImagesCarouselComponent {
    public readonly currentIndex: WritableSignal<number> = signal(0);
    public readonly images = input.required<string[]>();
    public isLandscape = true;

    public getCurrentImage(): string {
        return this.images()[this.currentIndex()];
    }

    public goToNextImage(): void {
        const isLastImage = this.currentIndex() === this.images().length - 1;

        this.currentIndex.set(isLastImage ? 0 : this.currentIndex() + 1);
    }

    public goToPreviousImage(): void {
        if (!this.images().length) {
            return;
        }

        const isFirstImage = this.currentIndex() === 0;

        this.currentIndex.set(isFirstImage ? this.images().length - 1 : this.currentIndex() - 1);
    }

    public onImageLoad(event: Event): void {
        const img = event.target as HTMLImageElement;
        this.isLandscape = img.naturalWidth > img.naturalHeight;
    }
}
